/* Carousel */
import { startCarousel, carouselIndicatorClick } from "./js/carousel";
import { rbtShowTags } from "./js/components";
import { mobileSubmenuToggle, openMobileMenu, closeMobileMenu } from "./js/mobile";

window.rbtShowTags = rbtShowTags;
window.startCarousel = startCarousel;
window.carouselIndicatorClick = carouselIndicatorClick;

function toggleSearch(event) {
  const searchWrap = event.target.closest('.search-wrap');
  const navbar = searchWrap.previousElementSibling;
  searchWrap.classList.toggle('active');
  navbar.classList.toggle('hidden');
  searchWrap.querySelector('input').focus();

}
function submitSearch(event) {
  const form = event.target.closest('form');
  form.submit();
}

function mobileFooterClicks(e) {
  e.preventDefault();
  const target = e.target;
  const link = target.tagName == 'A' ? target : target.querySelector('a');
  if (link.getAttribute('href') == '#') {
    let li = target.closest('LI');
    let subMenu = li.querySelector('.sub-menu');
    if (subMenu) {
      li.classList.toggle('sub-menu-open');
    }
  }
}
window.mobileFooterClicks = mobileFooterClicks;
window.mobileSubmenuToggle = mobileSubmenuToggle;
window.closeMobileMenu = closeMobileMenu;
window.openMobileMenu = openMobileMenu;
window.submitSearch = submitSearch;
window.toggleSearch = toggleSearch;
